import { render } from "./ProductTile.vue?vue&type=template&id=5e9e5b0b&scoped=true"
import script from "./ProductTile.vue?vue&type=script&lang=js"
export * from "./ProductTile.vue?vue&type=script&lang=js"

import "./ProductTile.vue?vue&type=style&index=0&id=5e9e5b0b&scoped=true&lang=css"

import exportComponent from "/Users/felix/dev/projects/protfolio/schillerando-demo/schillerando-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9e5b0b"]])

export default __exports__